import { createSlice } from '@reduxjs/toolkit'

const productDetailSlice = createSlice({
    name: 'sizing',
    initialState: {
        products: []
    },
    reducers: {
        fetchProductDetailAction: (state, action) => {
            state.products = action.payload
        }
    }
})
export const {fetchProductDetailAction} = productDetailSlice.actions


export default productDetailSlice